export const addSponsorModalFormStyle = {
	content: {
		display: 'flex',
		gap: '12px',
		width: '100%',
		flexDirection: 'column',
		marginBottom: '130px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '970px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 120px',
			},
		},
	},

	logo: {
		marginTop: '20px',
		maxHeight: '100px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},
	},

	logoWrapper: {
		height: '100px',
		marginBottom: '20px',
	},

	activeLogo: {
		'& > div': {
			height: '100px',
		},
	},
};
